import { useCallback } from "react";
import {
  useDisableDealer,
  useEnableDealer,
} from "../mutations/useStatusDealerToggle.mutation";

export const useDealerStatusToggle = () => {
  const disableMutation = useDisableDealer();
  const enableMutation = useEnableDealer();

  const handleEnable = useCallback(
    (id: string) => {
      enableMutation.mutate(id);
    },
    [enableMutation],
  );

  const handleDisable = useCallback(
    (id: string) => {
      disableMutation.mutate(id);
    },
    [disableMutation],
  );

  return {
    handleDisable,
    isDisabling: disableMutation.isPending,
    handleEnable,
    isEnabling: enableMutation.isPending,
  };
};
